<pux-icon-slot v-if="model" :icon="model" :label="model" :in-dropdown="false"></pux-icon-slot>